import React from "react";

function View(props, { locals }) {
  const { query } = locals;
  const { redirect } = query;
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt="My Stength Book"
      />
      <div className="frame">
        <div className="Maintenance">
          <div className="head">Scheduled Maintenance in Progress</div>
          <div className="body">
            <p>
              We are currently updating MyStrengthBook with some brand new
              features. This scheduled maintenance will only take 2-3 hours.
              When you check back you'll have amazing new tools to make you
              stronger. Thanks for your patience and see you soon!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const Maintenance = (app) => {
  app.get("/maintenance", ({ res }) => (res.body = <View />));
};

export default Maintenance;
